import React, { useRef, useEffect, useState } from "react";
import LiquidacionSelect from "../../../components/select/LiquidacionSelect";
import EstadoSelect from "../../../components/select/EstadoSelect";
export default function FiltroEjecucionDeLiquidaciones({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {
  const filtroRef = useRef(null);

  // ============================
  //        ESTADO (rehidratable)
  // ============================
  
  const [codigoLiquidacion, setCodigoLiquidacion] = useState(
    initialFilters.codigoLiquidacion ?? ""
  );

const [estado, setEstado] = useState(initialFilters.estado ?? null);

  const [liquidacion, setLiquidacion] = useState(
  initialFilters.liquidacion ?? null
);


  const [dataFecha, setDataFecha] = useState(initialFilters.dataFecha ?? "");
  const [dataFechaini, setDataFechaini] = useState(
    initialFilters.dataFechaini ?? ""
  );
  const [dataFechafin, setDataFechafin] = useState(
    initialFilters.dataFechafin ?? ""
  );

  const [valorTotalCliente, setValorTotalCliente] = useState(
    initialFilters.valorTotalCliente ?? ""
  );
  const [totalIvaCliente, setTotalIvaCliente] = useState(
    initialFilters.totalIvaCliente ?? ""
  );
  const [totalIvaEess, setTotalIvaEess] = useState(
    initialFilters.totalIvaEess ?? ""
  );

  const [valorTotalEess, setValorTotalEess] = useState(
    initialFilters.valorTotalEess ?? ""
  );
  const [qnRemitosProc, setQnRemitosProc] = useState(
    initialFilters.qnRemitosProc ?? ""
  );
  const [valorTotalDescPetr, setValorTotalDescPetr] = useState(
    initialFilters.valorTotalDescPetr ?? ""
  );
  const [valorTotalDescEess, setValorTotalDescEess] = useState(
    initialFilters.valorTotalDescEess ?? ""
  );
  const [valorTotalDescLibe, setValorTotalDescLibe] = useState(
    initialFilters.valorTotalDescLibe ?? ""
  );
  const [valorTotalBonificacion, setValorTotalBonificacion] = useState(
    initialFilters.valorTotalBonificacion ?? ""
  );
  const [qnFactura, setQnFactura] = useState(initialFilters.qnFactura ?? "");
  const [qnNotaCredito, setQnNotaCredito] = useState(
    initialFilters.qnNotaCredito ?? ""
  );
  const [qnClieSinFacturar, setQnClieSinFacturar] = useState(
    initialFilters.qnClieSinFacturar ?? ""
  );

  // ============================
  //   CERRAR CLICK FUERA / ESC
  // ============================
  useEffect(() => {
    const outside = (e) => {
      if (filtroRef.current && !filtroRef.current.contains(e.target)) {
        onClose();
      }
    };

    const esc = (e) => e.key === "Escape" && onClose();

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // ============================
  //        SUBMIT
  // ============================
  const handleSubmit = (e) => {
    e.preventDefault();

    const toNull = (v) => (String(v ?? "").trim() === "" ? null : String(v).trim());

    onSubmit({
  // ✅ UI (rehidratable)
  estado,
  liquidacion,

  // ✅ backend (primitivos)
  codigoLiquidacion: toNull(codigoLiquidacion),
  estadoId: estado?.id ?? null,
  liquidacionId: liquidacion?.id ?? null,

  dataFecha: toNull(dataFecha),
  dataFechaini: toNull(dataFechaini),
  dataFechafin: toNull(dataFechafin),

  valorTotalCliente: toNull(valorTotalCliente),
  totalIvaCliente: toNull(totalIvaCliente),
  totalIvaEess: toNull(totalIvaEess),

  valorTotalEess: toNull(valorTotalEess),
  qnRemitosProc: toNull(qnRemitosProc),

  valorTotalDescPetr: toNull(valorTotalDescPetr),
  valorTotalDescEess: toNull(valorTotalDescEess),
  valorTotalDescLibe: toNull(valorTotalDescLibe),
  valorTotalBonificacion: toNull(valorTotalBonificacion),

  qnFactura: toNull(qnFactura),
  qnNotaCredito: toNull(qnNotaCredito),
  qnClieSinFacturar: toNull(qnClieSinFacturar),
});

  };

  // ============================
  //        RENDER
  // ============================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          
          {/* Código Liquidación */}
          <div>
            <label className="form-label-fil">Código Liquidación</label>
            <input
              className="input"
              value={codigoLiquidacion}
              onChange={(e) => setCodigoLiquidacion(e.target.value)}
              maxLength={60}
            />
          </div>

          {/* Estado (legacy: select estado) */}
          <div>
            <label className="form-label-fil">Estado</label>
            {/* Reemplazar por tu componente estándar (EstadoSelect) */}
            <EstadoSelect
                value={estado}
                tipoId={8}
                onChange={setEstado}
            />
          </div>

          {/* Liquidación (legacy: select liquidacion) */}
          <div>
            <label className="form-label-fil">Liquidación</label>
            {/* Reemplazar por tu componente estándar (LiquidacionSelect) */}
            <LiquidacionSelect
                value={liquidacion}
                onChange={setLiquidacion}
            />
          </div>

          {/* Fechas */}
          <div>
            <label className="form-label-fil">Fecha</label>
            <input
              type="date"
              className="input"
              value={dataFecha}
              onChange={(e) => setDataFecha(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label-fil">Fecha Inicio</label>
            <input
              type="date"
              className="input"
              value={dataFechaini}
              onChange={(e) => setDataFechaini(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label-fil">Fecha Fin</label>
            <input
              type="date"
              className="input"
              value={dataFechafin}
              onChange={(e) => setDataFechafin(e.target.value)}
            />
          </div>

        

          <div className="text-right">
            <button type="submit" className="btn">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
